import "./style.css";

export const ButtonSkeleton = ({ variant = 'round', style }) => (
  <div className={`button skeleton-loader`} style={{...style, borderRadius: variant === 'round' ? '10em' : 'inherit'}}/>
);